







import { Vue, Component, Prop } from 'vue-property-decorator'
import HttpPost from './HttpPost.vue'
import ActionButton from '../form/ActionButton.vue'

@Component({
  components: { ActionButton, HttpPost }
})
export default class PostActionButton extends Vue {
  @Prop() label!: string
  @Prop() url!: string
  @Prop() to!: string
  @Prop({ default: 'primary' }) variant!: string;
  @Prop() icon: string
  @Prop({ default: '' }) body!: any

  isSuccessFull = true
  response = []

  $refs: {
    button: ActionButton;
    http: HttpPost;
  }

  handleResponse (fetch) {
    this.$refs.button.isLoading = fetch.isFetching
    this.response = fetch.data

    this.$emit('response', this.response)
  }

  handleSuccess (success: boolean) {
    this.isSuccessFull = success

    this.$emit('success', this.response)
  }

  post () {
    this.$refs.http.post()
  }
}
